export const email = {
    pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
}

// Common email domain typos and their corrections
export const commonEmailTypos = {
    // Gmail typos
    'gmial.com': 'gmail.com',
    'gamil.com': 'gmail.com',
    'gmal.com': 'gmail.com',
    'gmail.co': 'gmail.com',
    'gmail.cm': 'gmail.com',
    'gmail.con': 'gmail.com',
    'gmail.om': 'gmail.com',
    'gmai.com': 'gmail.com',
    'gmailc.om': 'gmail.com',
    'gmail.ocm': 'gmail.com',

    // Hotmail typos
    'hotmail.co': 'hotmail.com',
    'hotmail.cm': 'hotmail.com',
    'hotmail.con': 'hotmail.com',
    'hotmail.om': 'hotmail.com',
    'hotmial.com': 'hotmail.com',
    'hotmil.com': 'hotmail.com',
    'hotamail.com': 'hotmail.com',

    // Yahoo typos
    'yaho.com': 'yahoo.com',
    'yahooo.com': 'yahoo.com',
    'yahoo.co': 'yahoo.com',
    'yahoo.cm': 'yahoo.com',
    'yahoo.con': 'yahoo.com',
    'yahoo.om': 'yahoo.com',
    'yhaoo.com': 'yahoo.com',

    // Outlook typos
    'outlook.co': 'outlook.com',
    'outlook.cm': 'outlook.com',
    'outlook.con': 'outlook.com',
    'outlook.om': 'outlook.com',
    'outloo.com': 'outlook.com',
    'outlok.com': 'outlook.com',

    // Common TLD typos
    '.ew': '.ee',
    '.er': '.ee',
    '.con': '.com',
    '.cm': '.com',
    '.co': '.com',
    '.om': '.com',
    '.ocm': '.com',
    '.comm': '.com',
    '.cmo': '.com',
    '.net': '.net',
    '.ent': '.net',
    '.nett': '.net',
    '.orgg': '.org',
    '.ogr': '.org',
    '.rog': '.org'
};

// Function to check for common email typos and return a suggestion
export const checkEmailTypos = (email) => {
    if (!email || !email.includes('@')) return null;

    const [localPart, domain] = email.split('@');

    // Check for exact domain matches in our typo list
    if (commonEmailTypos[domain]) {
        return `${localPart}@${commonEmailTypos[domain]}`;
    }

    // Check for TLD typos (e.g., .con instead of .com)
    const lastDotIndex = domain.lastIndexOf('.');
    if (lastDotIndex !== -1) {
        const domainName = domain.substring(0, lastDotIndex);
        const tld = domain.substring(lastDotIndex);

        if (commonEmailTypos[tld]) {
            return `${localPart}@${domainName}${commonEmailTypos[tld]}`;
        }
    }

    return null;
};

export const matchValue = (fieldName, getValues) => value => value === getValues()[fieldName]
